import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

const token = localStorage.getItem('token');
const initialState = token
    ?  'success'
    :  '' ;
 


export default new Vuex.Store({
  state: {
    key_shift: false, 
    status: initialState,
    rooms: [],
    token: localStorage.getItem('token') || '',

    user : {},
    userId: null,

    user_customer: false, 
    user_company: null, 

    locations: [],

    allProducts: null, 

    //socket: null, 
    initParams: {}, 

    billings: [],  

  },
  getters : {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    allComponents: state => {
      let m = []
      for (let k of state.cl_components) {
        m.push({ text: k.name, value: k._id })
      }
      return m
    },
   
  },
  mutations: {


    auth_request(state){
      state.status = 'loading'
    },
    auth_success(state, payload) {
      state.status = 'success'
      state.token = payload.token
      state.user = payload.user
      state.user_customer = payload.user_customer
      state.user_company = payload.user_company
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      localStorage.removeItem('token')
      state.status = ''
      state.token = ''
      state.user_customer = null
      state.user_company = null
    },
    cl_components(state, payload){
      state.cl_components = payload
    }
  },
  actions: {
    api_error ({ commit } ) {
    
      commit('logout')
      router.push({ name: 'logout' })
    },
    //socket_connect({ commit, state }, error) {

    //}
  }
})
